import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggleButton", "toggleContent", "iconOpen", "iconClose", "toggleSwitch", "switchIcon"];

  connect() {
    // Initialize aria-expanded based on the initial visibility
    this.toggleButtonTarget.setAttribute('aria-expanded', !this.toggleContentTarget.classList.contains('hidden'));
    // Setup initial state for the toggle switch component
    if (this.hasToggleSwitchTarget) {
      this.toggleSwitchTarget.setAttribute('aria-checked', 'false');  // Assumes the switch is off by default
    }
  }

  toggleContent() {
    const isVisible = this.toggleContentTarget.classList.toggle("hidden");
    this.toggleContentTarget.classList.toggle("block");
    this.iconOpenTarget.classList.toggle("hidden");
    this.iconCloseTarget.classList.toggle("hidden");
    // Update aria-expanded to reflect the new state of the content
    this.toggleButtonTarget.setAttribute('aria-expanded', !isVisible);
  }

  toggleSwitch() {
    if (!this.hasToggleSwitchTarget) return;

    const isChecked = this.toggleSwitchTarget.getAttribute('aria-checked') === 'true';
    this.toggleSwitchTarget.setAttribute('aria-checked', !isChecked);
    const switchIcon = this.switchIconTarget; // Assume switchIconTarget is correctly set to the span that should move

    // Toggle the translate classes for the switch
    switchIcon.classList.toggle('translate-x-5', !isChecked);
    switchIcon.classList.toggle('translate-x-0', isChecked);

    if (isChecked) {
      this.toggleSwitchTarget.classList.remove('bg-lime-600')
      this.toggleSwitchTarget.classList.add('bg-gray-200')
    } else {
      this.toggleSwitchTarget.classList.add('bg-lime-600')
      this.toggleSwitchTarget.classList.remove('bg-gray-200')
    }

    // Manage opacity and transition for the inner icons
    const icons = switchIcon.querySelectorAll('span[aria-hidden="true"]');
    icons[0].classList.toggle('opacity-100', isChecked);
    icons[0].classList.toggle('opacity-0', !isChecked);
    icons[0].classList.toggle('duration-200', isChecked);
    icons[0].classList.toggle('duration-100', !isChecked);

    icons[1].classList.toggle('opacity-0', isChecked);
    icons[1].classList.toggle('opacity-100', !isChecked);
    icons[1].classList.toggle('duration-100', isChecked);
    icons[1].classList.toggle('duration-200', !isChecked);
  }
}
